import axios from "axios";
import getEndpoint from "../getEndpoint";

const ngrokSkipWarning = {headers: {"bypass-tunnel-reminder": "true"} };

export async function CreateOrder(credentials: any){
    const response = await axios.post(`${getEndpoint()}/api/Order/CreateOrder`, credentials, ngrokSkipWarning);
    //console.log(response.data);
    return response.data;
}

export async function GetAllOrder() {
    const response = await axios.get(`${getEndpoint()}/api/Order/GetAll`, ngrokSkipWarning);
    //console.log(response.data);
    return response.data;
}

export async function GetAllOrderByUser(uid: string) {
    const response = await axios.get(`${getEndpoint()}/api/Order/GetAllByUser?uid=${uid}`, ngrokSkipWarning);
    //console.log(response.data);
    return response.data;
}

export async function GetAllOrderProductsByOrderId(uid: string|undefined) {
    const response = await axios.get(`${getEndpoint()}/api/OrderProduct/GetAllByOrderId?id=${uid}`, ngrokSkipWarning);
    //console.log(response.data);
    return response.data;
}

export async function GetOrder(id: string|undefined) {
    const response = await axios.get(`${getEndpoint()}/api/Order/Get?id=${id}`, ngrokSkipWarning);
    //console.log(response.data);
    return response.data;
}

export async function UpdateOrderStatus(credential: any) {
    const response = await axios.put(`${getEndpoint()}/api/Order/UpdateStatus`, credential, ngrokSkipWarning);
    //console.log(response.data);
    return response.data;
}

export async function DeleteOrder(id:any) {
    const response = await axios.delete(`${getEndpoint()}/api/Order/Delete?id=${id}`, {
        ...ngrokSkipWarning
    });
    return response.data;
}
